import { hasTripEnded } from '@src/business-rules/reservation-management';
import { useTripListItem } from '@src/contexts/trip-list-item-context';

import { OnGoingFutureTripCard } from './ongoing-future-trip-card/ongoing-future-trip-card';
import { PastCanceledTripCard } from './past-canceled-trip-card/past-canceled-trip-card';

const TripPreviewCard = () => {
  const { trip } = useTripListItem();
  const isPastOrCancelledTrip = ['Canceled'].includes(trip.status) || hasTripEnded(trip);

  if (isPastOrCancelledTrip) {
    return <PastCanceledTripCard />;
  }

  return <OnGoingFutureTripCard />;
};

export default TripPreviewCard;
